import { ServiceComplaintTypeStore } from './service-complaint-type.store';
import { Component, inject, viewChild } from '@angular/core';
import {
    routeParams,
    translate,
} from '../../../../../modules/shared/shared.global-service';
import { CardTableComponent } from '../../../../../modules/shared/components/kit/table/card-table.component';
import { getComplaintTypeFrag } from './service-complaint-type.query';
import {
    TableColumn,
    TableColumnType,
} from '../../../../../modules/shared/components/kit/table/table.types';
import {
    activeColumn, nameColumn,
} from '../../../../../modules/shared/components/kit/table/table.fields';
import { BaseDialogService } from '../../../../kit/base-dialog/base-dialog-service';
import { TableComponent } from '../../../../../modules/shared/components/kit/table/table.component';
import {
    ServiceComplaintTypeDetailDialogComponent,
} from '../service-complaint-type-detail-dialog/service-complaint-type-detail-dialog.component';
import {
    ServiceComplaintTypeObject,
} from '@libs/types/src/services/object-type/service/settings/service-complaint-type.object';
import { contentGlobalSuccess } from '../../../../../modules/content/content.error';
import { ConfirmBuilder } from '../../../../../modules/shared/service/confirm.builder';

@Component({
    selector: 'app-service-complaint-type',
    templateUrl: './service-complaint-type.component.html',
    styleUrl: './service-complaint-type.component.scss',
    standalone: true,
    providers: [ServiceComplaintTypeStore],
    imports: [
        CardTableComponent,
    ],
})
export class ServiceComplaintTypeComponent {
    public readonly store = inject(ServiceComplaintTypeStore);
    public dialogService = inject(BaseDialogService);
    public confirm = inject(ConfirmBuilder);
    public readonly complaintTypeTable = viewChild<TableComponent>('complaintTypeTable');

    protected columns: TableColumn[] = [
        activeColumn,
        nameColumn,
        {
            name: 'daysToProcess',
            type: TableColumnType.Number,
        },
    ];

    create() {
        this.dialogService.open(
            ServiceComplaintTypeDetailDialogComponent,
            {
                header: translate.instant('service.complaintType.dialog.create'),
                styleClass: 'p-dialog-width-30',
            },
        ).onClose.subscribe((it) => {
            it && this.complaintTypeTable()?.reload();
        });
    }

    detail(complaintType: ServiceComplaintTypeObject) {
        this.dialogService.open(
            ServiceComplaintTypeDetailDialogComponent,
            {
                header: translate.instant('service.complaintType.dialog.edit'),
                styleClass: 'p-dialog-width-30',
                data: { complaintType },
            },
        ).onClose.subscribe((it) => {
            it && this.complaintTypeTable()?.reload();
        });
    }

    async delete(event: any) {
        this.confirm.confirmDelete(
            async () => {
                await this.store.api.deleteComplaintType({ id: event.item.id });
                contentGlobalSuccess.next('common.deleted');
                this.complaintTypeTable()?.reload();
            },
            event,
        );
    }

    protected readonly routeParams = routeParams;
    protected readonly getComplaintTypeFrag = getComplaintTypeFrag;
}


